import { AiStatus } from '@rp/contracts'
import { useQuery } from '@tanstack/react-query'
import { nullWhenAbsent } from '../api/absent'
import { useReadySession } from '../session/useSession'

export const AI_STATUS_PATH = '/v1/ai-status'
export const AI_STATUS_REFRESH_MS = 60_000

export const aiStatusKeys = {
  tenant: (tenantId: string) => ['ai-status', tenantId] as const,
}

export const useAiStatus = () => {
  const { api, membership } = useReadySession()
  return useQuery({
    queryKey: aiStatusKeys.tenant(membership.tenantId),
    queryFn: async () =>
      nullWhenAbsent(api.request(AiStatus, { method: 'GET', path: AI_STATUS_PATH }).then((result) => result.data)),
    refetchInterval: AI_STATUS_REFRESH_MS,
  })
}
